export default "__VITE_ASSET__3ce4cfb8__"